"use client"

import { 
    cryptoReadState, 
    setCRMenu, 
    setCRShowEmailPop, 
    setCRShowSubscribePop,
    setCREmail,
 } from "@/slices/cryptoReadSlice";
import CRMenuPop from "./CRMenuPop";
import CREmailPop from "./CREmailPop";
import CRSubscribePop from "./CRSubscribePop";

// cr 彈窗
const { useDispatch, useSelector } = require("react-redux")

const CRModals = () =>{
    const dispatch = useDispatch();
    const {
        showCRMenu,
        showCRShowEmailPop,
        showCRSubscribePop,
    } = useSelector(cryptoReadState);

    return(
        <>
            {/* 選單 */}
            <CRMenuPop
                showCRMenu = {showCRMenu}
                dispatch = {dispatch}
                setCRMenu = {setCRMenu}
            />

            {/* email 驗證 */}
            <CREmailPop
                showCRShowEmailPop={showCRShowEmailPop}
                setCRShowEmailPop={setCRShowEmailPop}
            />

            {/* 訂閱電子報 */}
            <CRSubscribePop
                showCRSubscribePop={showCRSubscribePop}
                setCRShowSubscribePop={setCRShowSubscribePop}
                setCREmail={setCREmail}
            />
        </>
    )
}

export default CRModals;